module.exports = "/_next/static/images/FrameMobile-bd45ed8a2751277d1278e5a5bb7f682e.webp";